const theme = {
    palette: {
        primary: {
            main: '#f58220',
            contrastText: '#fff'
        }
    }
};

export default theme;